import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=27cfffdd"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cfffdd')) {
      api.createRecord('27cfffdd', component.options)
    } else {
      api.reload('27cfffdd', component.options)
    }
    module.hot.accept("./ShippingAddress.vue?vue&type=template&id=27cfffdd", function () {
      api.rerender('27cfffdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/funders/view/ShippingAddress.vue"
export default component.exports